import img1 from '../Images/lap_image1.jfif';
import img2 from '../Images/lap_image2.jfif';
import img3 from '../Images/lap_image3.jfif';
import img4 from '../Images/lap_image4.webp';
import img5 from '../Images/lap_image5.jfif';
import img6 from '../Images/lap_image6.jfif';
import img7 from '../Images/lap_image7.webp';
import img8 from '../Images/lap_image8.webp';
import img9 from '../Images/lap_image9.webp';


const LapData = {
    productData:[
        {
            id:19,
            img:img1,
            title:'HP Pavilion x360',
            desc:'HP Pavilion x360 14-dh1011tu 8GB02PA#ACJ Core i5 10th Gen Windows 10 Home Laptop (8 GB RAM, 1 TB HDD + 256 GB SSD, Intel UHD Graphics, 35.56cm, Natural Silver)',
            price:64000,
        },
        {
            id:20,
            img:img2,
            title:'Dell Vostro 15 350',
            desc:'10th Generation Intel® Core™ i3-1005G1 Processor (4MB Cache, up to 3.4 GHz) laptop Windows 10 Home Single Language, English Intel® UHD Graphics',
            price:35500,
        },
        {
            id:21,
            img:img3,
            title:'Apple MacBook Pro',
            desc:'Apple MacBook Pro is a macOS laptop with a 13.30-inch display that has a resolution of 2560x1600 pixels.',
            price:40000,
        },
        {
            id:22,
            img:img4,
            title:'Lenovo IdeaPad',
            desc:'Lenovo Ideapad 330 Intel Core i5 8th Gen 15.6-inch Laptop (8GB/2TB HDD/DOS/2GB Graphics/Platinum Grey/ 2.2kg)',
            price:50000,
        },
        {
            id:23,
            img:img5,
            title:'Acer Aspire',
            desc:'Acer Aspire 3 A315-23 15.6" (39.62cms) Laptop (AMD Athlon Silver 3050U dual-core/4GB/1TB HDD/Window 10)',
            price:29000,
        },
        {
            id:24,
            img:img6,
            title:'HP ChromeBook',
            desc:'HP Chromebook 14-inch (35.56 cms) Thin & Light Touchscreen Laptop (Celeron N4020/4GB/64GB eMMC/ Mineral Silver)',
            price:35000,
        },
        {
            id:25,
            img:img7,
            title:'Dell Inspiron',
            desc:'Dell Inspiron - Windows OS - 14 in - 500 GB drive - Hard Disk Drive - 4 GB RAM - Touchscreen - 1.6 GHz CPU - Intel CPU',
            price:25000,
        },
        {
            id:26,
            img:img8,
            title:'HP Mini Laptop',
            desc:'HP Mini Laptop - Windows OS · 12.1 in · 160 GB drive · 8 GB RAM · 2.1 GHz CPU · Intel CPU · Netbook · Intel GPU · Dual Core',
            price:50000,
        },
        {
            id:27,
            img:img9,
            title:'Dell Inspiron 5567',
            desc:'New Dell Inspiron 5567 · Windows OS · 15.6 in · 1 TB drive · Solid State Drive · Hard Disk Drive · 12 GB RAM · Touchscreen · Intel CPU',
            price:45000,
        },
    ],
};

export default LapData;